import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { IHotelsDraftItem, IHotelsItem } from 'store/slices/hotels/interfaces';
import { resetHotelItem } from 'store/slices/hotels/hotelsSlice';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadHotelsItem,
  saveHotelsItem,
  saveHotelsItemAsDraft,
} from 'store/slices/hotels/actions';
import { StatusesEnum } from 'constants/status';

import { HotelsForm } from './components/HotelsForm/HotelsForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.hotels);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { b2cUrl } = useAppSelector(state => state.configSlice);

  React.useEffect(() => {
    dispatch(loadHotelsItem(id));
    return () => {
      dispatch(resetHotelItem());
    };
  }, []);

  const onFinish = (values: IHotelsItem) => {
    setIsLoading(true);
    dispatch(saveHotelsItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/hotels');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IHotelsDraftItem) => {
    setIsLoading(true);
    dispatch(saveHotelsItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/hotels');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/hotels');
  };

  const getOgSiteName = () => {
    if (!item) return null;

    const sysName = item.sysName || '';
    const linkToB2C =
      item.lang === 'en'
        ? `${b2cUrl}/en/hotels/${id}/${sysName}`
        : `${b2cUrl}/hotels/${id}/${sysName}`;

    return linkToB2C;
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item?.id && item.id === Number(id) ? (
        <HotelsForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          initialValues={{
            ...mapValuesToForm(item),
            ogUrl: getOgSiteName(),
            ogSiteName: 'Посети Кавказ',
            ogType: 'hotels',
          }}
        />
      ) : null}
    </MainLayout>
  );
};
